import type { z } from '@framework/zod';

type TRangeSchema = z.ZodType;

const validateRange = (
  min: string,
  max: string,
  schema?: TRangeSchema,
): { minError?: string, maxError?: string } => {
  if (!schema) {
    return {};
  }

  const result = schema.safeParse({ min, max });
  if (result.success) return {};

  const { fieldErrors } = (result.error as z.ZodError).flatten();
  return {
    minError: (fieldErrors as Record<string, string[]>).min?.[0],
    maxError: (fieldErrors as Record<string, string[]>).max?.[0],
  };
};

export { validateRange };
export type { TRangeSchema };
